import {
  Search,
  ChevronRight,
  ArrowUp,
  Check,
  X,
  Plus,
  Settings,
  Trash2,
  Sparkles,
  Bell,
  Loader2,
  Heart,
  type Icon,
} from "@aisquare/ui/icons";
import { IconButton } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

// Dogfood the hard rule: this page imports icons ONLY from
// "@aisquare/ui/icons" — never "lucide-react" directly.
const SAMPLE: { name: string; Glyph: Icon }[] = [
  { name: "Search", Glyph: Search },
  { name: "ChevronRight", Glyph: ChevronRight },
  { name: "ArrowUp", Glyph: ArrowUp },
  { name: "Check", Glyph: Check },
  { name: "X", Glyph: X },
  { name: "Plus", Glyph: Plus },
  { name: "Settings", Glyph: Settings },
  { name: "Trash2", Glyph: Trash2 },
  { name: "Sparkles", Glyph: Sparkles },
  { name: "Bell", Glyph: Bell },
  { name: "Heart", Glyph: Heart },
  { name: "Loader2", Glyph: Loader2 },
];

export function IconsDemo() {
  return (
    <Section
      id="icons"
      title="Icons"
      description="The single sanctioned icon source. Import from @aisquare/ui/icons — never lucide-react directly — so the icon provider stays a seam we own. lucide-react is externalized, so named imports stay fully tree-shakeable. ~1500 glyphs available; a representative set shown below."
    >
      <VariantBlock label="Sample set" caption='import { Search, … } from "@aisquare/ui/icons"'>
        <div className="grid grid-cols-3 gap-3 sm:grid-cols-4 md:grid-cols-6">
          {SAMPLE.map(({ name, Glyph }) => (
            <div
              key={name}
              className="flex flex-col items-center gap-2 rounded-xl border border-border bg-card p-4"
            >
              <Glyph className="size-5 text-foreground" />
              <span className="text-[11px] text-muted-foreground">{name}</span>
            </div>
          ))}
        </div>
      </VariantBlock>

      <VariantBlock label="Size + stroke" caption="size / strokeWidth / color via props (IconProps)">
        <div className="flex items-end gap-6">
          <Sparkles className="size-4 text-muted-foreground" />
          <Sparkles className="size-6 text-foreground" />
          <Sparkles className="size-8 text-primary" />
          <Sparkles className="size-8 text-accent" strokeWidth={1} />
          <Sparkles className="size-8 text-accent" strokeWidth={2.5} />
        </div>
      </VariantBlock>

      <VariantBlock label="In an IconButton" caption="any lucide glyph drops into IconButton (Icon type)">
        <div className="flex items-center gap-3">
          <IconButton aria-label="Search"><Search className="size-4" /></IconButton>
          <IconButton aria-label="Add"><Plus className="size-4" /></IconButton>
          <IconButton aria-label="Settings"><Settings className="size-4" /></IconButton>
          <IconButton aria-label="Delete"><Trash2 className="size-4" /></IconButton>
        </div>
      </VariantBlock>
    </Section>
  );
}
